<template>
  <div class="width98 margin-auto">
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <div class="width100">
      <!-- 检索 -->
      <div
        class="backwhite border-rd3 flexleft"
        style="min-height: 120px"
        v-if="serchkey"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          size="small"
          class="demo-ruleForm width100 flexleft"
        >
          <el-form-item label="企业名称 ">
            <el-input
              placeholder="请输入企业名称"
              v-model="ruleForm.keycompany"
            ></el-input> </el-form-item
          ><el-form-item label="企业类型 ">
            <el-radio-group v-model="radio">
              <el-radio :label="1">包含关键字</el-radio>
              <el-radio :label="2">以关键字开头</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="margin-left30 width70">
            <el-button type="primary" size="mini" @click="submitForm()"
              >检 索</el-button
            >
            <el-button class="resetbtn" size="mini" @click="resetForm()"
              >重 置</el-button
            >
          </div>
        </el-form>
      </div>

      <div
        class="
          width100
          backwhite
          pad-top20 pad-bot30
          margin-auto margin-top15
          border-rd3
        "
        v-if="pages != ''"
      >
        <el-table
          :data="pages"
          stripe
          style="width: 98%"
          class="eltable margin-auto f14"
        >
          <el-table-column label="企业名称" width="380">
            <template slot-scope="scope">
              <span
                style="color: #52c5cb"
                class="f14 cursorpointer"
                @click="todetails(scope.row)"
              >
                {{ scope.row.company }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="cert_id" label="信用代码" width="280">
          </el-table-column>
          <el-table-column prop="register_date" label="成立日期">
          </el-table-column>
          <el-table-column prop="legal_representative" label="法人代表">
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <span
                style="color: #52c5cb"
                class="f14 cursorpointer"
                @click="addteadmarkfollow(scope.row)"
                >加入关注</span
              >
              <span
                style="color: #52c5cb"
                class="f14 cursorpointer margin-left10"
                @click="addpantensearch(scope.row)"
                >专利检索</span
              >
              <span
                style="color: #52c5cb"
                class="f14 cursorpointer margin-left10"
                @click="addteadmarksearch(scope.row)"
                >商标检索</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="width100 margin-auto backgroudFFF margin-top15"
        v-if="pages == ''"
      >
        <el-empty
          :image="require('@/assets/barsvg/zwsj@3x.png')"
          :image-size="200"
          description="抱歉，没有搜到您想要的内容"
          class="heightempty"
        >
          <p style="position: relative; bottom: 60px" class="f14">暂无数据</p>
        </el-empty>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { entsearch, ADDmonitordetail } from "@/api/patent/patent.api";
import { followtrademarkfllow } from "@/api/Center/Center.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      input2: "",
      ruleForm: {
        keycompany: "",
      },
      radio: 2,
      thisNum: 1,
      pages: [],
      total: 0,
      currentPage: 0,
      serchkey: true,
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    refresh() {
      this.$loading.show(); // 显示loading
      if (window.sessionStorage.getItem("keycompany") == null) {
        this.$loading.hide(); // 隐藏loading
        return;
      } else {
        entsearch({
          company: window.sessionStorage.getItem("keycompany"),
          limit: 20,
          page: this.thisNum,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 清空input
    resetForm() {
      this.ruleForm.keycompany = "";
      this.pages = "";
    },
    // 保存企业key
    todetails(row) {
      window.sessionStorage.setItem("company_key", row.client_key);
      this.$router.push({ path: "/Data-Homepage/Enterprise-details" });
    },
    // 加入关注
    addteadmarkfollow(row) {
      ADDmonitordetail({ company_name: row.company }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入关注",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 专利检索、
    addpantensearch(row) {
      window.sessionStorage.setItem("patenteep", row.company);
      this.$router.push({ path: "/Data-Homepage/Patent-search" });
    },
    // 商标检索
    addteadmarksearch(row) {
      window.sessionStorage.setItem("register", row.company);
      this.$router.push({ path: "/Data-Homepage/Trademark-search" });
    },
    // 企业检索
    submitForm() {
      this.$loading.show(); // 显示loading
      window.sessionStorage.setItem("keycompany", this.ruleForm.keycompany);
      window.sessionStorage.setItem("keyradio", this.radio);
      entsearch({
        company: this.ruleForm.keycompany,
        query_type: this.radio,
        limit: 20,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data;
          this.$message({
            showClose: true,
            message: "检索成功",
            type: "success",
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      if (this.ruleForm.keycompany == "" || this.ruleForm.keycompany == null) {
        entsearch({
          company: window.sessionStorage.getItem("keycompany"),
          query_type: window.sessionStorage.getItem("keyradio"),
          page: this.thisNum,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entsearch({
          company: this.ruleForm.keycompany,
          query_type: this.radio,
          page: this.thisNum,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pages = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 分页
    currentchange(val) {
      if (this.ruleForm.keycompany == "" || this.ruleForm.keycompany == null) {
        entsearch({
          company:
            this.ruleForm.keycompany == "" || null
              ? window.sessionStorage.getItem("keycompany")
              : this.ruleForm.keycompany,
          query_type: window.sessionStorage.getItem("keyradio"),
          limit: 20,
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        entsearch({
          company: this.ruleForm.keycompany,
          query_type: this.radio,
          limit: 20,
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pages = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.$loading.show(); // 显示loading
    if (
      window.sessionStorage.getItem("keycompany") == null ||
      window.sessionStorage.getItem("keycompany") == ""
    ) {
      this.$loading.hide(); // 隐藏loading
      return;
    } else {
      entsearch({
        company: window.sessionStorage.getItem("keycompany"),
        query_type: window.sessionStorage.getItem("keyradio"),
        limit: 20,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    }
  },
};
</script>
<style scoped>
.Keywordsinput >>> .el-input__inner {
  height: 50px;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 23px 0 0 23px;
  position: relative;
  left: 40%;
}
.Keywordsinput >>> .el-input-group__append,
.el-input-group__prepend {
  width: 60px;
  text-align: center;
  color: #fff;
  background: #52c5cb;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 0px 100px 100px 0px;
  position: relative;
  left: 30%;
  font-size: 16px;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>